import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LogOut, LayoutDashboard, ListPlus, Settings as SettingsIcon, CreditCard } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const onLogout = async () => { await logout(); nav("/"); };

  return (
    <header className="w-full border-b border-[#EBE5DF] bg-[#F9F8F6]/80 backdrop-blur-sm sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-sm bg-[#1E3F33] grid place-items-center">
            <span className="text-white font-serif-display text-lg leading-none">IR</span>
          </div>
          <span className="font-serif-display text-xl text-[#1E3F33]">IVA Radar</span>
        </Link>
        <nav className="flex items-center gap-2">
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="hidden sm:flex items-center gap-2 px-3 py-2 text-sm text-[#2C2C2C] hover:text-[#1E3F33]">
                <LayoutDashboard size={16} /> Cruscotto
              </Link>
              <Link to="/movimenti" data-testid="nav-movimenti" className="hidden sm:flex items-center gap-2 px-3 py-2 text-sm text-[#2C2C2C] hover:text-[#1E3F33]">
                <ListPlus size={16} /> Movimenti
              </Link>
              <Link to="/piani" data-testid="nav-pricing" className="hidden sm:flex items-center gap-2 px-3 py-2 text-sm text-[#2C2C2C] hover:text-[#1E3F33]">
                <CreditCard size={16} /> Piani
              </Link>
              <Link to="/impostazioni" data-testid="nav-settings" className="hidden sm:flex items-center gap-2 px-3 py-2 text-sm text-[#2C2C2C] hover:text-[#1E3F33]">
                <SettingsIcon size={16} /> Impostazioni
              </Link>
              <button data-testid="nav-logout" onClick={onLogout} className="btn-lift ml-2 flex items-center gap-2 px-4 py-2 text-sm border border-[#EBE5DF] rounded-md hover:bg-[#EBE5DF]">
                <LogOut size={14} /> Esci
              </button>
            </>
          ) : (
            <>
              <Link to="/piani" data-testid="nav-pricing" className="px-3 py-2 text-sm text-[#2C2C2C] hover:text-[#1E3F33]">Piani</Link>
              <Link to="/accedi" data-testid="nav-login" className="px-3 py-2 text-sm text-[#2C2C2C] hover:text-[#1E3F33]">Accedi</Link>
              <Link to="/registrati" data-testid="nav-register" className="btn-lift px-4 py-2 text-sm bg-[#1E3F33] text-white rounded-md hover:bg-[#152D24]">
                Inizia ora
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
